import React from "react";

export default function StatusSamenvatting(color) {
	const style1 = {
		"fill": "#702f8a",
		"fillOpacity": "1",
		"stroke": "#702f8a",
		"strokeWidth": "0.03342481",
		"strokeMiterlimit": "4",
		"strokeDasharray": "none",
		"strokeOpacity": "1"
	};

	const style2 = {
		"fill": "#702f8a",
		"fillOpacity": "1",
		"fillRule": "nonzero",
		"stroke": "#702f8a",
		"strokeWidth": "0.03342481",
		"strokeMiterlimit": "4",
		"strokeDasharray": "none",
		"strokeOpacity": "1"
	};

	return (<svg id="Laag_1" viewBox="0 0 14 14" width="51px" height="80px">
		<g
			id="layer1"
			transform="translate(-28.589409,-24)">
			<g
				transform="matrix(0.3410962,0,0,-0.35952471,-220.29355,257.01265)"
				id="g4519"
				style={style1}>
				<g
					id="g4521"
					clipPath="url(#clipPath4525)"
					style={style1}>
					<g
						id="g4527"
						transform="translate(739.0497,617.3265)"
						style={style1}>
						<path
							d="m 0,0 h -1.61 c -0.487,0 -0.909,0.312 -1.052,0.778 l -4.639,15.11 c -0.102,0.331 -0.04,0.698 0.168,0.977 0.205,0.278 0.535,0.446 0.884,0.446 h 21.536 c 0.486,0 0.908,-0.312 1.052,-0.776 L 21.197,0.711 20.144,0.389 15.287,16.212 -6.249,16.211 -1.61,1.1 H 0 Z"
							style={style2}
							id="path4529"
						/>
					</g>
					<g
						id="g4531"
						transform="translate(759.5668,617.3276)"
						style={style1}>
						<path
							d="M 0,0 H -20.838 V 1.1 H 0 c 0.378,0 0.707,0.243 0.818,0.605 L 4.931,15.104 5.983,14.782 1.87,1.383 C 1.616,0.555 0.865,0 0,0"
							style={style2}
							id="path4533"
						/>
					</g>
					<g
						id="g4535"
						transform="translate(765.1006,630.5254)"
						style={style1}>
						<path
							d="M 0,0 -1.052,0.322 0.245,4.547 -6.551,4.539 C -6.618,4.306 -6.712,4.022 -6.821,3.696 -6.934,3.356 -7.063,2.97 -7.198,2.544 -7.345,2.086 -7.766,1.776 -8.247,1.776 h -1.717 v 1.1 h 1.717 c 0.137,0.433 0.268,0.823 0.383,1.169 0.106,0.317 0.198,0.593 0.268,0.822 0.142,0.461 0.561,0.772 1.045,0.772 h 6.803 c 0.345,0 0.674,-0.167 0.88,-0.444 C 1.335,4.919 1.398,4.556 1.297,4.226 Z"
							style={style2}
							id="path4537"
						/>
					</g>
					<g
						id="g4539"
						transform="translate(759.8616,619.0527)"
						style={style1}>
						<path
							d="m 0,0 -1.052,0.324 3.494,11.335 h -6.955 v 1.1 h 8.444 z"
							style={style2}
							id="path4541"
						/>
					</g>
					<path
						d="m 762.506,629.061 h -6.399 v 1.1 h 6.399 z"
						style={style2}
						id="path4543"
					/>
					<path
						d="m 761.956,627.404 h -5.09 v 1.1 h 5.09 z"
						style={style2}
						id="path4545"
					/>
				</g>
			</g>
		</g>
	</svg >);
}
